export default {
  maintenaceSlogan: '我们很快就会回来！',
  maintenanceMessage:
    '我们目前正在进行定期维护，以改善我们的服务。对此给您带来的不便我们深感抱歉，感谢您的耐心等待。请稍后再来查看',
  maintenanceAction: '需要帮助?',
  linkToDiscord: '联系我们的支持团队',
}
